export enum HubMessageTypeEnum {
    Notification = "Notification"
}